import { useState } from "react";
import { NavLink } from "react-router-dom";

export function InventoryNav(props) {
  const [items] = useState([
    {
      name: "Inventory Entry",
      to: "inventory-entry",
    },
    {
      name: "Item Issuer",
      to: "item-issuer",
    },
    /* {
      name: "Branches Inventory",
      to: "branches-inventory",
    }, */
    {
      name: "Vendor",
      to: "vendor",
    },
    {
      name: "Manage Transaction",
      to: "manage-transaction",
    },

    {
      name: "Item Manager",
      to: "inventory-manager",
    },
    {
      name: "Item Conversion",
      to: "item-conversion",
    },
    {
      name: "Items Below Reorder Level",
      to: "items-out-of-stock",
    },
    {
      name: "Items Expiry Report",
      to: "items-expiry-report",
    },
    {
      name: "Shipping Cost",
      to: "shopping-cost",
    },
  ]);

  return (
    <div className="dashboard-tabs innerpage-tabs px-4">
      <ul className="nav nav-tabs">
        {items.map((item, index) => (
          <li key={index} className="nav-item">
            <NavLink className={`nav-link ga-nav-tab`} to={item.to}>
              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
